import { Permission } from './permission.enum';
import { LookupBase } from '../models/utils/lookup-base.model';

export const PERMISSION_LOOKUP: LookupBase[] = [
  { value: Permission.create, description: 'Create' },
  { value: Permission.read, description: 'Read' },
  { value: Permission.write, description: 'Write' },
  { value: Permission.delete, description: 'Delete' },
];
